import Bugsnag from '@bugsnag/js'
import groove from 'api/groove'
import { logError } from 'util/debug'

import { oauthTokenSelector } from 'selectors/app'
import { selectBusinessHours } from '../selectors'
import {
  BUSINESS_HOURS_SAVE_REQUEST,
  BUSINESS_HOURS_SAVE_RESPONSE,
  BUSINESS_HOURS_SAVE_ERROR,
} from '../types'
import { serializeBusinessHours } from '../util'

export default function doBusinessHoursSave() {
  return (dispatch, getState) => {
    const state = getState()
    const token = oauthTokenSelector(state)
    const businessHours = selectBusinessHours(state)
    dispatch(doBusinessHoursSaveRequest())
    return groove
      .put(
        token,
        `/v2/reports/business_hours`,
        null,
        serializeBusinessHours(businessHours)
      )
      .then(result => {
        dispatch(doBusinessHoursSaveResponse(result.json))
      })
      .catch(error => {
        logError(error)
        Bugsnag.notify(error)
        dispatch(doBusinessHoursSaveError(error))
      })
  }
}

function doBusinessHoursSaveRequest() {
  return {
    type: BUSINESS_HOURS_SAVE_REQUEST,
  }
}

function doBusinessHoursSaveResponse(result) {
  return {
    type: BUSINESS_HOURS_SAVE_RESPONSE,
    payload: {
      result,
    },
  }
}

function doBusinessHoursSaveError(error) {
  return {
    type: BUSINESS_HOURS_SAVE_ERROR,
    payload: {
      error,
    },
  }
}
